<template>
  <router-link :to="link" v-if="link" :class="cssClass" :style="cssStyle">
    <button type="button">
      <slot></slot>
    </button>
  </router-link>
  <button type="button" v-else :class="cssClass" :style="cssStyle">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'TheButton',

  props: {
    cssClass: String,
    cssStyle: String,
    link: {
      type: String,
      default: null,
    },
  },
};
</script>
